import React from 'react'
import {Button as AntButton} from 'antd'
import './index.scss'

const Button = ({
  children,
  className = '',
  type = 'default',
  secondary = false,
  ...rest
}) => {
  const classNames = ['custom']
  if (type) classNames.push(type)
  if (className) classNames.push(className)
  if (secondary) classNames.push('secondary')

  return (
    <AntButton
      className={classNames.join(' ').trim()}
      {...rest}
    >
      {children}
    </AntButton>
  )
}

export default Button
